import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { fetchIntegrationConfig, fetchIntegrationsData } from "../thunks";

interface Integration {
  name: string;
  config: Record<string, any>;
}

interface IntegrationsState {
  items: Integration[];
  status: "idle" | "loading" | "succeeded" | "failed";
  error: string | null;
}

const initialState: IntegrationsState = {
  items: [],
  status: "idle",
  error: null,
};

const integrationsSlice = createSlice({
  name: "integrations",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchIntegrationsData.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchIntegrationsData.fulfilled, (state, action: PayloadAction<string[]>) => {
        state.status = "succeeded";
        state.items = action.payload.map((item) => ({
          name: item,
          config: {},
        }));
      })
      .addCase(fetchIntegrationsData.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || action.error.message || "Failed to fetch Integrations";
      })
      .addCase(fetchIntegrationConfig.pending, (state) => {
                state.status = "loading";
            })
            .addCase(fetchIntegrationConfig.fulfilled, (state, action) => {
                state.status = "succeeded";
                const index = state.items.findIndex((item) => item.name === action.payload.name);
                if (index !== -1) {
                    state.items[index] = {
                        ...state.items[index],
                        config: action.payload.config
                    }
                }
            })
            .addCase(fetchIntegrationConfig.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload || action.error?.message || "Failed to fetch the integration config";
            })
  },
});

export default integrationsSlice.reducer;
